var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { css } from 'aphrodite/no-important';
import { JourneysSelectors, useAppSelector } from "conversional-journey";
import { ComponentStyles } from 'conversional-theme';
import createComponentsFromObject from '../../utilities/components/createComponentsFromObject';
import { renderClasses } from './Container.styles';
import QuestionBox from './QuestionBox';
var QuestionContainer = function (_a) {
    var textBox = _a.textBox, description = _a.description, children = _a.children, styles = _a.styles, spots = _a.spots, titleOnImage = _a.titleOnImage, questionTextBoxContainerClassName = _a.questionTextBoxContainerClassName;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var className = "".concat(titleOnImage ? renderClasses().overlapContainer : renderClasses().container, " ").concat(css(ComponentStyles(styles)));
    var useBox = textBox || description;
    var getTextBox = function () {
        if (!textBox)
            return null;
        var containerClassName = textBox.containerClassName, rest = __rest(textBox, ["containerClassName"]);
        return __assign(__assign({}, rest), { containerClassName: questionTextBoxContainerClassName || containerClassName });
    };
    return (_jsxs("div", { className: className, children: [useBox && (_jsx(QuestionBox, { description: description, textBox: getTextBox(), children: spots && spots.inTextBox && createComponentsFromObject({ inTextBox: spots.inTextBox }) })), _jsx(React.Fragment, { children: children })] }));
};
export default QuestionContainer;
